import { setDefaultColorsIfNeeded } from '../../components/FortuneWheel/WheelColors'
import LotteryConfigurationResponse from '@tootsweet/model/lottery/LotteryConfigurationResponse'

export default function renderCustomCss(
  lotteryConfig?: LotteryConfigurationResponse
) {
  if (!lotteryConfig) {
    lotteryConfig = {}
  }

  setDefaultColorsIfNeeded(lotteryConfig)

  if (!lotteryConfig) {
    return null
  }

  return `
    body, p, h1, a.descLink, a.descLink:hover, a.descLink:visited, a.descLink:active {
      color: ${lotteryConfig.colBodyFont} !important;
    }
    .k-glm-optin > .checkbox-text {
      color: ${lotteryConfig.colBodyFont} !important;
    }
    @media (min-width: 768px) {
      html, body, #root {
        background-color: ${
          lotteryConfig.colSidesDesktop || lotteryConfig.colFooterBack
        } !important;
      }
    }
    .game-container:not(.no-bg), .loader-wrapper-fixed {
      background-color: ${lotteryConfig.colBodyBack} !important;
    }
    .h2, .h4 {
      color: ${lotteryConfig.colBodyFont} !important;
    }
    .highlight {
      color: ${lotteryConfig.colHighlight} !important;
    }
    .w-modal h2, .w-modal p, .w-modal h1, .w-modal ol, .w-modal .control-label, .w-modal input, .w-modal label {
      color: ${lotteryConfig.colModalFont} !important;
    }
    .bottom-legal-container, .bottom-legal, .bottom-legal:visited, .bottom-legal:hover, .quizz-header {
      color: ${lotteryConfig.colFooterFont} !important;
      background-color: ${lotteryConfig.colFooterBack} !important;
    }
    .w-button-normal, .w-button-normal:hover, .w-button-normal:visited, .w-button-normal:active, .w-button:focus,
    .w-tutorial-choice, .w-tutorial-choice:hover, .w-tutorial-choice:visited, .w-tutorial-choice:active, .w-tutorial-choice:focus {
      color: ${lotteryConfig.colCTAFont} !important;
      background-color: ${lotteryConfig.colCTABack} !important;
    }
    .w-btn-disabled {
      background-color: ${lotteryConfig.colCTADisabledBack} !important;
      color: ${lotteryConfig.colCTADisabledFont} !important;
    }
    .lds-ring > div > div {
      border: 8px solid ${lotteryConfig.colLoader} !important;
      border-color: ${
        lotteryConfig.colLoader
      } transparent transparent transparent !important;
    }
    .lds-ring-dark > div > div {
      border: 8px solid #0e0074 !important;
      border-color: #0e0074 transparent transparent transparent !important;
    }
    .lds-text, .lds-text-down {
      color: ${lotteryConfig.colLoader} !important;
    }
    .w-btn-inverted, .w-btn-inverted:hover, .w-btn-inverted:visited, .w-btn-inverted:active, .w-btn-inverted:focus {
      border: 1px solid ${lotteryConfig.colCTABack} !important;
      background-color: ${lotteryConfig.colCTAFont} !important;
      color: ${lotteryConfig.colCTABack} !important;
    }
    .h1-scratchcard, .h1-advent-calendar {
      color: ${lotteryConfig.colBodyFont} !important;
    }
    .logo-header:not(.no-bg) {
      background-color: ${lotteryConfig.colHeader || 'transparent'} !important;
    }
    .w-voucher-border {
      border: 2px solid ${lotteryConfig.colBodyFont} !important;
    }
    .k-glm-title-1 {
      color: ${lotteryConfig.colBodyFont} !important; 
    }
    .k-glm-title-2 {
      color: ${lotteryConfig.colHighlight} !important;
    }
    `
}
